import React from "react"
import  MainCP from "../../../Components/apruebo-rechazo/apruebo-rechazo-v3/MainCP"

const ViewAprueboRechazo: React.FC = () => <MainCP/>
export default ViewAprueboRechazo;